import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort, MatSortModule, MatSortHeader } from '@angular/material/sort';
import { RxStompService } from '../../rx-stomp.service';
import { Message } from '@stomp/stompjs';
import config from '../../../../auth_config.json';
import { DecimalPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-clusters',
  templateUrl: './clusters.component.html',
  styleUrls: ['./clusters.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DecimalPipe, DatePipe]
})
export class ClustersComponent implements OnInit {
  apiUrl = config.apiUri;
  windingUrl = config.windingUri;
  geometriesUrl = config.geometriesUri;
  visUrl = config.visUri;
  queueUrl = config.queueUri;
  hasApiError = false;
  apiError: string;
  // @ts-ignore, to suppress warning related to being undefined
  private statusSubscriptions: Array<Subscription>;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [
    'id',
    'name',
    'node_count',
    'cpu',
    'memory',
    'last_seen',
    'actions'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private api: ApiService,
    private configFactory: AuthClientConfig,
    private rxStompService: RxStompService,

  ) { }

  ngOnInit(): void {
    this.getClusters();
  }

  getClusters() {
    this.api.getClusters$().subscribe({
      next: (res) => {
        this.hasApiError = false;
        this.dataSource = new MatTableDataSource<any>(res);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;


        if (!this.statusSubscriptions) {
          this.statusSubscriptions = [];
        }

        for (const cluster of res) {
          // Subscribe to status updates
          this.statusSubscriptions.push(this.rxStompService
            .watch(`/topic/${cluster.name}.cluster.status`)
            .subscribe((msg: Message) => {
              const updatedCluster = JSON.parse(msg.body);
              const index = this.dataSource.data.findIndex(c => c.id === updatedCluster.id);
              if (index !== -1) {
                this.dataSource.data[index] = { ...this.dataSource.data[index], ...updatedCluster };
                this.dataSource._updateChangeSubscription(); // Notify the table about the data change
              }
            }));
        }
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }

  deleteCluster(id: string) {
    this.api.deleteClustersId$(id).subscribe({
      next: () => {
        this.hasApiError = false;
        this.getClusters()
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }

  refreshCluster(id: string) {
    this.api.getClusters$().subscribe({
      // Do nothing - kicks off an async refresh
    });
  }
}
